// eslint-disable-next-line
import util from 'util';

import * as CoreApi from './core/api';
import * as coreActions from './core/actions';

//
// Handle push notifications
//
var store = null;
var subscription = null;

function base64ToArray(base64String) {
  var padding = '='.repeat((4 - base64String.length % 4) % 4);
  var base64 = (base64String + padding)
    .replace(/-/g, '+')
    .replace(/_/g, '/');

  var rawData = window.atob(base64);
  var outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i)  {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

function arrayToBase64( buffer ) {
    var binary = '';
    var bytes = new Uint8Array( buffer );
    var len = bytes.byteLength;
    for (var i = 0; i < len; i++) {
      binary += String.fromCharCode( bytes[ i ] );
    }
    return window.btoa( binary );
}

//
// Register with the push server
//
function pushSubscribe(registration, key) {
  registration.pushManager.subscribe({
    "applicationServerKey" : key,
    "userVisibleOnly" : true
  }).then(function(newSubscription) {
    subscription = newSubscription;
    store.dispatch(coreActions.setupPushNotification(subscription.endpoint,
                                                     arrayToBase64(subscription.getKey('p256dh')),
                                                     arrayToBase64(subscription.getKey('auth'))));
  }).catch(function(error) {
    util.log('Subscription error: ', error);
  });
}

//
// Unregister with the push server
//
export function pushUnsubscribe() {
  if (subscription != null) {
    subscription.unsubscribe().then(function() {
      subscription = null;
    }).catch(function(error) {
      util.log('Subscription error: ', error);
    });
  } else {
    util.log('Nothing to unsubscribe');
  }
}


//
// Setup the service worker
//
export function setup(newStore) {
  store = newStore;

  if (navigator.serviceWorker) {
    /* Add handler for when service worker is ready */
    navigator.serviceWorker.ready.then(function(registration) {
      /* Get the server public key and then register */
      CoreApi.getWebApiPublicKey((response) => {
        let key = base64ToArray(response.publicKey);
        pushSubscribe(registration, key);
      });
    });

    /* Start the service worker */
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('push-worker.js')
               .then(function(registration) {
               }).catch(function(error) {
                 util.log('Service Worker Registration Error: ', error.message);
               });
    }
  }
}

